export { P2pActionBtnComponent } from './p2p-action-btn/p2p-action-btn.component';
export { P2pSkinImageComponent } from './p2p-skin-image/p2p-skin-image.component';
export { P2pStickerImageComponent } from './p2p-sticker-image/p2p-sticker-image.component';
